
const getCachedUrl = (cachedPdfsData, pdfUrl) => {
	return cachedPdfsData.get(pdfUrl);
}


export {getCachedUrl}